import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HealthcareSecurityAssessment from './components/HealthcareSecurityAssessment';
import GoogleAnalytics from './components/GoogleAnalytics';

// Create router with future flags enabled
const router = createBrowserRouter(
  [
    {
      path: "*",
      element: (
        <div className="min-h-screen bg-slate-300">
          <header className="bg-white border-b border-slate-300 shadow-sm">
            <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
              <h1 className="text-3xl font-bold text-slate-800">Healthcare Security Assessment 2026</h1>
            </div>
          </header>
          <main>
            <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
              <div className="px-4 py-6 sm:px-0">
                <HealthcareSecurityAssessment />
                <GoogleAnalytics />
              </div>
            </div>
          </main>
        </div>
      ),
    },
  ],
  {
    // Apply future flags to resolve warnings
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  }
);

function App() {
  // Use the RouterProvider without separate GoogleAnalytics
  return <RouterProvider router={router} />;
}

export default App; 